import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger, setActiveStepOnBody } from '../utils';

export const shippingStepSubmittedConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.SHIPPING_STEP_SUBMITTED,
  handler: ({ detail }) => {
    logger('Shipping Step Submitted');
    setActiveStepOnBody(detail.activeStepType);
    console.log(detail);
  },
};
